var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".burger{fill:none;stroke:#01104B;stroke-linecap:square;stroke-width:5px;}")),React.createElement("g",{"transform":"translate(2.5 2.5)","key":1},[React.createElement("line",{"className":"burger","x2":"24","key":0}),React.createElement("line",{"className":"burger","x2":"24","transform":"translate(0 12)","key":1}),React.createElement("line",{"className":"burger","x1":"24","transform":"translate(0 24)","key":2})])]);
}

Burger.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29"};

module.exports = Burger;

Burger.default = Burger;
